import _sortBy from 'lodash/sortBy';

import { TransferToAgentItem } from '../transferToAgentDropdown';

/**
 * Sort function to order TransferToAgentItems first by status (including
 * disabled status), and then alphabetically
 *
 * @param transferToAgentItems The items to sort
 * @param disabledItems All disabled TransferToAgentItem ids
 * @returns TransferToAgentItem[] sorted array of TransferToAgentItems
 */
export function sortTransferToAgentItems(
  transferToAgentItems: readonly TransferToAgentItem[],
  disabledItems: TransferToAgentItem['id'][],
) {
  return _sortBy(transferToAgentItems, [
    function (element) {
      const rank = {
        working: 1,
        acw: 2,
        away: 3,
        offline: 4,
        unknown: 5,
      };
      if (disabledItems.includes(element.id)) {
        return 100;
      }
      return rank[element.status];
    },
    function (element) {
      return element.name ?? '';
    },
  ]);
}
